import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { SaService } from 'smartauction-frontend-micro-library';
import { LaunchDarklyService } from 'remarketing-angular-library';
import { UserService, AccountManagerResultDto } from 'remarketing-angular-library';
import { take } from 'rxjs/operators';

@Injectable()
export class AccountManagerService extends SaService {

  private readonly _launchDarklyService = inject(LaunchDarklyService);
  private readonly _userService = inject(UserService);
  private _accountManagers: AccountManagerResultDto[] = [];
  private _getAccountManagersComplete$: WritableSignal<boolean> = signal(false);

  constructor() {
    super();
    this.getAccountManagers();
  }

  get isEmployeeFilterEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('sim-employeeFilterEnabled', false);
  }

  get accountManagers(): AccountManagerResultDto[] {
    return this._accountManagers;
  }

  get getAccountManagersCompleteSignal(): Signal<boolean> {
    // make this getter a read-only signal to allow other components and services to update dynamically upon the completed network request.
    return this._getAccountManagersComplete$ as Signal<boolean>;
  }

  private getAccountManagers(): void {
    if (this.isEmployeeFilterEnabled) {
      this._userService.getAccountManagers().pipe(take(1)).subscribe({
        next: (result: AccountManagerResultDto[]) => {
          this._accountManagers = result;
          this._getAccountManagersComplete$.set(true);
        },
        error: (error) => {
          console.error(error);
        }
      });
    }
  }
}
